import icons from '../components/Icons';

export default Object.keys(icons.cardLogos);
